// utils
import _ from 'lodash';
import { codeGeneretor } from 'app/utils';
import PadItemState from './PadItemState';

/**
 * represents an instance of PadItem
 * @class PadItem
 */
export default class PadItem {
  /**
   * @param {object} state - pad creator element state
   * @returns {this}
   */
  constructor(state) {
    if (new.target === PadItem) {
      throw new Error('PadItem is an abstract class.');
    }

    this._state = _.cloneDeep(state);
    this._screenData = _.cloneDeep(state.data.screen);
    this._loadedData = _.cloneDeep(state.data.loaded);
  }

  replace(padItems) {
    this._screenData = [];
    const state = this._state;

    const padItemState = new PadItemState(state);

    // eslint-disable-next-line no-unused-vars
    for (const padItem of padItems) {
      const padState = padItemState.getPadItemType(padItem);
      padItem.eventItemType = padState;
      padItem.code = codeGeneretor();
      this._screenData.push(padItem);
    }

    return this;
  }

  getState() {
    this._state.data.screen = this._screenData;
    this._state.data.loaded = this._loadedData;
    return this._state;
  }
}
